export class ArgumentNullError extends Error {
    constructor(parameterName: string, parameterValue: any) {
        super(`${parameterName} has null value: ${parameterValue}`)
        this.name = 'ArgumentNullError'
    }
}
